import axios from "axios";
class ScreenPermissionServices {

    getScreenPermissionByParentName = async ({ queryKey }) => {
        const [_key, payload] = queryKey;
        if (payload) {
            return await axios.post(`/ScreenPermission/GetScreenPermissionByParentName`, payload);
        }
        console.warn("payload not provided, ScreenPermissionServices.getScreenPermissionByParentName");
        return null;
    };

    get_EffectiveScreen_Permission = async ({ queryKey }) => {
        const [_key, payload] = queryKey;
        if (payload) {
            return await axios.post(`/EffectivePermission/GetData_EffectiveScreenPermission`, payload);
        }
        console.warn("payload not provided, ScreenPermissionServices.get_EffectiveScreen_Permission");
        return null;
    };
}

const instance = new ScreenPermissionServices();

export default instance;
